import React, { useState, useEffect } from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import { useNavigate } from 'react-router-dom';
import { ACTIONS, KEYS, URLS } from '../../_config';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import Icon from '../../components/icons';
import moment from 'moment';
import { DateRangePicker } from 'rsuite';
import "rsuite/dist/rsuite.css";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import Filter from '../../components/filter';
import PersonalInformation from './personalInformation';
import StoreInformation from './storeInformation';
import Header from '../../components/header';
import BranchInformation from './branchInformation';

const Profile: React.FC = () => {
    const [filterValue, setFilterValue] = useState<any>({});
    const [activeTab, setActiveTab] = useState<string>('personal');

    const navigate = useNavigate();

    const { register, formState: { errors }, handleSubmit, } = useForm<any>();
    const handleTabChange = (tab: string) => {
        setActiveTab(tab);
    };

    useEffect(() => {
    }, []);

    const handleApplyFilter = (filterData: any) => {
        setFilterValue(filterData);
    };

    const handleClearFilter = () => {
        setFilterValue(null);
    };

    return (
        <div className="flex">
            <SideMenuBar sideMenuBarClass={'w-64 h-screen w-1/6 bg-white '} />
            <div className="w-full h-screen w-5/6 bg-sky-50 overflow-y-auto" style={{ maxHeight: '100vh' }}>
                <Header />
                <div className="p-8">
                    <h1 className="text-xl font-semibold text-gray-600 mb-2">Settings</h1>

                    {/* Paragraph */}
                    <p className="text-sm text-gray-400 mb-6"></p>
                    <div className="flex justify-between mb-5 mobile-display-block">
                        <div className="flex-1">
                            <div className="bg-white shadow-none rounded-2xl p-6 mb-5 mx-auto overflow-y-auto" style={{ maxHeight: '100vh' }}>
                                <div className="flex border-b">
                                    <div
                                        className={`cursor-pointer py-2 px-6 ${activeTab === 'personal' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'}`}
                                        onClick={() => handleTabChange('personal')}
                                    >
                                        Personal Info
                                    </div>

                                    <div
                                        className={`cursor-pointer py-2 px-6 ${activeTab === 'store' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'}`}
                                        onClick={() => handleTabChange('store')}
                                    >
                                        Store Info
                                    </div>

                                    <div
                                        className={`cursor-pointer py-2 px-6 ${activeTab === 'branch' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'}`}
                                        onClick={() => handleTabChange('branch')}
                                    >
                                        Branch Info
                                    </div>

                                </div>

                                {activeTab === 'personal' && (
                                    <PersonalInformation activeTab={activeTab} />
                                )}

                                {activeTab === 'store' && (
                                    <StoreInformation activeTab={activeTab} />
                                )}

                                {activeTab === 'branch' && (
                                    <BranchInformation activeTab={activeTab} />
                                )}
                            </div>
                        </div>

                        {/* <div className="w-80 p-6 ml-4">

                        </div> */}
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Profile;